/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";

export class DungeonQuestServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }
}